<template>
  <div class="show-dropdown dropdown" :class="{'header': isHeader, 'notHeader': !isHeader }">
    <div class="dropdown-content">
      <div class="dropdown-wrapper">
        <div class="users is-flex">
          <div v-if="loading" class="loader"></div>
          <infinite-scroll :callback="loadMore">
            <div v-if="hasUsers" qa="dropdown_suggested_users">
              <div v-for="user in users" :key="user.userName" class="user is-flex" @click.stop="view(user)" qa="suggested_user" tabindex="0" @keypress.enter.space="view(user)">
                <div class="user-img" v-bind:style="{ 'background-image': 'url(' + avatar(user) + ')'}"></div>
                <div class="is-flex user-text">
                  <div class="user-name subtitle is-6 is-marginless">{{user.userName}}</div>
                </div>
              </div>
            </div>
            <div v-if="hasSchools" qa="dropdown_suggested_users">
              <div v-for="school in schools" :key="school._id" class="user is-flex" @click.stop="view(school)" qa="suggested_school" tabindex="0" @keypress.enter.space="view(school)">
                <div class="is-flex user-text">
                  <div class="user-name subtitle dropdown-rows is-marginless">{{school.title}}</div>
                </div>
              </div>
            </div>
            <div v-if="hasCounty" qa="dropdown_suggested_users">
              <div v-for="county in counties" :key="county._id" class="user is-flex" @click.stop="view(county)" qa="suggested_school" tabindex="0" @keypress.enter.space="view(county)">
                <div class="is-flex user-text">
                  <div class="user-name subtitle dropdown-rows is-marginless">{{county.county}}</div>
                </div>
              </div>
            </div>
          </infinite-scroll>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InfiniteScroll from '@/components/Controls/InfiniteScroll'
import imageProxy from '@/libs/image-proxy'

export default {
  components: {
    InfiniteScroll
  },

  props: ['users', 'loading', 'isHeader', 'isUserSearch', 'schools', 'isSchoolSearch', 'isCountySearch', 'counties'],

  computed: {
    hasUsers: function () {
      return this.users && this.users.length > 0
    },
    hasSchools: function () {
      return this.schools && this.schools.length > 0
    },
    hasCounty: function () {
      return this.counties && this.counties.length > 0
    }
  },

  methods: {
    close: function () {
      this.$emit('close')
    },

    view: function (user) {
      if (this.isSchoolSearch) {
        this.$emit('selectSchool', user)
      } else if (this.isCountySearch) {
        this.$emit('selectCounty', user)
      } else if (this.isUserSearch) {
        this.$emit('selectUser', user)
      } else {
        this.$router.push({ name: 'profile', params: { username: user.userName } })
      }
    },

    loadMore: function () {
      this.$emit('fetch')
    },

    avatar: function (user) {
      return user ? imageProxy.thumbnail(user.avatar) : ''
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  $mention-item-height: 36px;
  $mention-padding: 0.5rem;

  .show-dropdown {
    position: absolute;
    z-index: 3;
    min-width: 280px;
    height: auto;
  }
  .notHeader {
    bottom: 20px;
    padding-bottom: 4px;
    padding-top: initial;
    top: auto;
  }
  .header {
    top: 100%;
  }
  .dropdown-content {
    overflow: hidden;
    max-height: calc((#{$mention-item-height} * 5) + (#{$mention-padding} * 2));
    padding: 0;
  }
  .dropdown-rows {
    font-size: 0.8rem;
  }
  .dropdown-wrapper {
    padding: $mention-padding;
    height: 100%;
    max-height: 40vh;
    max-width: 27rem;
    overflow-y: auto;
    overflow-x: hidden;
    white-space: nowrap;
  }
  .dropdown-title {
    font-size: 1.3rem;
  }
  .users {
    flex-direction: column;
    flex-wrap: wrap;
    .user {
      padding: 0.5rem;
      align-items: center;
    }
    .user:hover {
      background-color: $white-ter;
    }
    .user-text {
      flex-direction: column;
      margin-left: 0.5rem;
    }
    .user-img {
      height: 20px;
      width: 20px;
      border-radius: 100%;
      background-size: cover;
      background-position: center;
      margin: 0;
      padding: 0;
    }
  }
  .top {
    padding-left: 0.5rem;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    .close{
      margin-left: 1rem;
      font-size: 0.9rem;
    }
  }
  .close, .user-img, .user-name{
    cursor: pointer;
  }

  .loader {
    margin: auto;
  }
</style>
